import { lazy } from 'react';
export { default as App } from './App'
export { default as Dashboard } from './Dashboard'


export { default as Login } from './Login'
export { default as Iframe } from './Iframe';


export const WorkBench = lazy(() => import('./WorkBench'))

// export { default as WorkBenchLeftContent } from './WorkBench/WorkBenchLeftContent.js'

export const CustomerCenter = lazy(() => import('./CustomerCenter'))

export const SetCenter = lazy(() => import('./SetCenter'))
// 账号管理
export const AccountList = lazy(() => import('./SetCenter/AccountList'))
// 批量派单规则
export const AssignmentRules = lazy(() => import('./SetCenter/AssignmentRules'))

// 业务中心-会话历史
export const CallRecord = lazy(() => import('./CallRecord'))

export const PolicySearch = lazy(() => import('./PolicySearch'))

export const LossPolicyList = lazy(() => import('./loss-policy-list'))

// 业务中心-包裹管理
export const ParcelManageList = lazy(() => import('./CustomerCenter/ParcelManage/List'))
export const ParcelManageEdit = lazy(() => import('./CustomerCenter/ParcelManage/Edit'))

// 客服通话记录
export const ServiceCallRecord = lazy(() => import('./CustomerCenter/ServiceCallRecord/index'))

export const AgentGroupSetting = lazy(() => import('./SetCenter/AgentGroupSetting'))

export const Statistics = lazy(() => import('./Statistics'))

export const OrgManage = lazy(() => import('./SetCenter/OrgManage'))

export const SetCompany = lazy(() => import('./SetCenter/SetCompany'))

export const MedicalAdjustment = lazy(() => import('./MedicalAdjustment'))

export const Ticket = lazy(() => import('./Ticket'))

export { default as InvoiceList } from './InvoiceList'

export const invoiceStatistics = lazy(() => import('./invoiceStatistics'))

export const BusinessMonitoring = lazy(() => import('./BusinessMonitoring/index'))

export const OperationMonitoring = lazy(() => import('./OperationMonitoring'))

export const GrayList = lazy(() => import('./GrayList'))

export const DataExport = lazy(() => import('./DataExport'))

export const RuleList = lazy(() => import('./RuleList'))

export const TrackSetting = lazy(() => import('./SetCenter/TrackSetting'))

export const MyTaskConfig = lazy(() => import('./SetCenter/MyTaskConfig'))

// 未决追踪配置
export const TrackSwitchConfig = lazy(() => import('./SetCenter/TrackSwitchConfig'))

export const EmployerCompanyManagement = lazy(() => import('./SetCenter/EmployerCompanyManagement'))

export const AdjustmentRules = lazy(() => import('./AdjustmentRules'))

export const InsurancePlan = lazy(() => import('./InsurancePlan'))

// 邮件管理
export const EmailManagement = lazy(() => import('./SetCenter/EmailManagement'))

// 排班管理
export const EmployeeShiftManagement = lazy(() => import('./SetCenter/EmployeeShiftManagement'))
// 跨机构派单
export const DispatchOrderManagement = lazy(() => import('./SetCenter/DispatchOrderManagement'))

// 我的任务，工单详情
export const WorkBenchReportDetail = lazy(() => import('../lossAss/containers/ReportTabs/ReportDetails.js'))

// 案件核赔
export const WorkBenchReportCheck = lazy(() => import('../lossAss/containers/ReportCheck'))

